/* Application: Example function
   ========================================================================== */

app.example = function() {
	'use strict';

	console.log('Application example function');
};
